import React from "react";
import "./BroadcastLayout.scss";
import { useSelector } from "react-redux";
import { selectIsAudienceViewExpanded } from "modules/broadcast/AudienceView/selectors";
import { selectShowTimer } from "modules/timer/redux/selectors";
import classNames from "classnames";
import { selectIsAudienceViewEnabled } from "../../event/selectors";

interface IPanelsProps {
  children: React.ReactNode;
}

export const Panels = ({ children }: IPanelsProps) => {
  const showTimerPanel = useSelector(selectShowTimer);
  const isAudienceViewExpanded = useSelector(selectIsAudienceViewExpanded);
  const isAudienceViewEnabled = useSelector(selectIsAudienceViewEnabled);

  return (
    <div
      className={classNames("panels", {
        "timer-enabled": showTimerPanel,
        "audience-view-expanded":
          isAudienceViewExpanded && isAudienceViewEnabled,
      })}
    >
      {children}
    </div>
  );
};

interface IBroadcastLayoutProps {
  children: React.ReactNode;
}

const BroadcastLayout = ({ children }: IBroadcastLayoutProps) => (
  <div className="broadcast-layout">{children}</div>
);

export default BroadcastLayout;
